import React from 'react';

interface WaveDividerProps {
    color?: string;
    flip?: boolean;
    className?: string;
}

const WaveDivider = ({
    color = '#0C2C39',
    flip = false,
    className = ''
}: WaveDividerProps) => {
    return (
        <div className={`w-full overflow-hidden leading-[0] ${flip ? 'rotate-180' : ''} ${className}`}>
            <svg
                viewBox="0 0 1200 120"
                preserveAspectRatio="none"
                className="relative block w-full h-[60px] md:h-[100px]"
                fill={color}
            >
                <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C58.47,105.77,114.71,114.36,173.34,103.58a449.1,449.1,0,0,0,148.05-47.14Z"></path>
            </svg>
        </div>
    );
};

export default WaveDivider;
